import React from 'react';
import { PrinterIcon, ScissorsIcon, HeartHandshakeIcon } from 'lucide-react';
type PrintCutShareProps = {
  align?: 'center' | 'start';
};
const items = [{
  label: 'Print',
  Icon: PrinterIcon
}, {
  label: 'Cut',
  Icon: ScissorsIcon
}, {
  label: 'Share',
  Icon: HeartHandshakeIcon
}];
export function PrintCutShare({
  align = 'center'
}: PrintCutShareProps) {
  return <p className={`flex flex-wrap items-center gap-x-2 gap-y-2 text-navy sm:gap-x-3 ${align === 'center' ? 'justify-center' : 'justify-center lg:justify-start'}`} aria-label="Print, cut, share" data-id="element-221" data-mp="205h2kn2tfkh6">
      {items.map(({
      label,
      Icon
    }, i) => <React.Fragment key={label} data-id="element-222" data-mp="1qe2wtxk9tofl" data-mpi={i}>
          {i > 0 && <span className="text-gold" aria-hidden="true" data-id="element-223" data-mp="1lgkoo9e2vd8n">•</span>}
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-[13px] font-extrabold uppercase tracking-[0.12em] sm:text-base sm:tracking-[0.16em]" data-id="element-224" data-mp="1lgavye1nerz9">
            <Icon className="h-4 w-4 text-coral sm:h-5 sm:w-5" aria-hidden="true" data-id="element-225" data-mp="2e46y3y9zlc3f" />
            {label}
          </span>
        </React.Fragment>)}
    </p>;
}